module.exports = __webpack_public_path__ + "img/2021_P1150083-1.a67f31b9.jpg";